export default "__VITE_ASSET__BrR9KB18__"